// extracted by mini-css-extract-plugin
export default {"modal-surroundings-section":"g4KFKNk3g26sv0VWDImb"};